/**
 * Copyright © Veeam Software Group GmbH.
 */

import { CompanyHealthStatus } from '@veeam-vspc/models/web-controllers';

export type CompanyStatus = CompanyHealthStatus;
export const CompanyStatus = CompanyHealthStatus;
